import Books from './Pages/Books';
import { BrowserRouter as Router, Route, Switch} from  'react-router-dom';
import BookData from './data/bookData.json';
import './books.css'
import './App.css'
import './imprint.css'
import './quotes.css'
import './randomBook.css'
import './ads.css'
import SnackbarProvider from 'react-simple-snackbar'
import BookDetails from './Pages/BookDetails';
import QuotePage from './Pages/QuotePage';
import RandomBook from './Pages/RandomBook';
import Imprint from './Pages/Imprint';
import AboutUs from './Pages/AboutUs';
import Contact from './Pages/Contact';

function App() {
  

  return (

    <div>

    <Router>
      <div className="App">
      <Switch>
        
        <Route exact path= '/'>
          <Books />
        </Route>

        <Route exact path= '/contact'>
          <Contact />
        </Route>

        <Route exact path= '/random-book'>
          <RandomBook/>
        </Route>
        
        <Route exact path= '/about-us'>
          <AboutUs/>
        </Route>


        <Route exact path= '/browse'>
          <QuotePage />
        </Route>

        <Route exact path= '/imprint'>
          <Imprint/>
        </Route>

        <Route  path= "/:key">
        <SnackbarProvider>
          <BookDetails/>
        </SnackbarProvider>
        </Route>

      </Switch>
        
      </div>
    </Router>
    
    </div>
  );
}

export default App;
